import React from 'react';
import { BrowserRouter, Routes, Route, } from "react-router-dom";
import Homepage from '../HomePage/HomePage'
import HomePage2 from '../HomePage2/HomePage2';
import HomePage3 from '../HomePage3/HomePage3';
import AboutPage from '../AboutPage/AboutPage';
import ServicePages from '../ServicePage/ServicePage';
import ServicePagesS2 from '../ServicePageS2/ServicePageS2';
import ServicePagesS3 from '../ServicePageS3/ServicePageS3';
import ServiceSinglePage from '../ServiceSinglePage/ServiceSinglePage';
import ProjectPage from '../ProjectPage/ProjectPage';
import ProjectPageS2 from '../ProjectPageS2/ProjectPageS2';
import ProjectPageS3 from '../ProjectPageS3/ProjectPageS3';
import ProjectSinglePage from '../ProjectSinglePage/ProjectSinglePage';
import TrackingPage from '../TrackingPage/TrackingPage';
import ShopPage from '../ShopPage/ShopPage'
import ProductSinglePage from '../ProductSinglePage';
import CartPage from '../CartPage';
import CheckoutPage from '../CheckoutPage';
import OrderRecived from '../OrderRecived';
import BlogPage from '../BlogPage/BlogPage'
import BlogPageLeft from '../BlogPageLeft/BlogPageLeft'
import BlogPageFullwidth from '../BlogPageFullwidth/BlogPageFullwidth'
import BlogDetails from '../BlogDetails/BlogDetails'
import BlogDetailsLeftSiide from '../BlogDetailsLeftSiide/BlogDetailsLeftSiide'
import BlogDetailsFull from '../BlogDetailsFull/BlogDetailsFull'
import ContactPage from '../ContactPage/ContactPage';
import ErrorPage from '../ErrorPage/ErrorPage';
import Tank3 from '../App/ProductPage/Tank3';
import Tank6 from '../App/ProductPage/Tank6';
import Tank10 from '../App/ProductPage/Tank10';
import WovenBag from '../App/ProductPage/WovenBag';
import PpFabric from '../App/ProductPage/PpFabric';
import MulticolorBag from '../App/ProductPage/MulticolorBag';
import LenoBag from '../App/ProductPage/LenoBag';
import CraftPaperBag from '../App/ProductPage/CraftPaperBag';
import CorrugatedBox from '../App/ProductPage/CorrugatedBox';
import TankLayer6 from '../App/ProductPage/TankLayer6';



const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="home" element={<Homepage />} />
          <Route path="home-2" element={<HomePage2 />} />
          <Route path="home-3" element={<HomePage3 />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="service" element={<ServicePages />} />
          <Route path="service-s2" element={<ServicePagesS2 />} />
          <Route path="service-s3" element={<ServicePagesS3 />} />
          <Route path="service-single/:slug" element={<ServiceSinglePage />} />
          <Route path="project" element={<ProjectPage />} />
          <Route path="project-s2" element={<ProjectPageS2 />} />
          <Route path="project-s3" element={<ProjectPageS3 />} />
          <Route path="project-single/:slug" element={<ProjectSinglePage />} />
          <Route path="tracking" element={<TrackingPage />} />
          <Route path="shop" element={<ShopPage />} />
          <Route path='shop-single/:slug' element={<ProductSinglePage />} />
          <Route path='cart' element={<CartPage />} />
          <Route path='checkout' element={<CheckoutPage />} />
          <Route path='order_received' element={<OrderRecived />} />
          <Route path='blog' element={<BlogPage />} />
          <Route path='blog-left-sidebar' element={<BlogPageLeft />} />
          <Route path='blog-fullwidth' element={<BlogPageFullwidth />} />
          <Route path='blog-single/:slug' element={<BlogDetails />} />
          <Route path='blog-single-left-sidebar/:slug' element={<BlogDetailsLeftSiide />} />
          <Route path='blog-single-fullwidth/:slug' element={<BlogDetailsFull />} />
          <Route path='contact' element={<ContactPage />} />
          <Route path='tank3' element={<Tank3 />} />
           <Route path='tank6' element={<Tank6 />} />
            <Route path='tank10' element={<Tank10 />} />
             <Route path='wovenBag' element={<WovenBag />} />
              <Route path='ppFabric' element={<PpFabric />} />
              <Route path='multicolorBag' element={<MulticolorBag/>} />
              <Route path='lenoBag' element={<LenoBag />} />
              <Route path='craftPaperBag' element={<CraftPaperBag />} />
              <Route path='corrugatedBox' element={<CorrugatedBox />} />
               <Route path='tanklayer6' element={<TankLayer6 />} />
          <Route path='404' element={<ErrorPage />} />
        
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default AllRoute;
